const columnLabels = {
    IMPRESSIONS: 'Impressions',
    CLICKS: 'Clicks',
    CTR: 'CTR',
    VIEWABLE_IMPRESSIONS: 'Viewable Imp.',
    VIEW_RATE: 'View Rate',
    STARTS: 'Started Views',
    FIRST_QUARTILES: 'First Quartile Views',
    MIDPOINTS: 'Midpoint Views',
    THIRD_QUARTILES: 'Third Quartile Views',
    COMPLETES: 'Completed Views',
    COMPLETION_RATE: 'Completion Rate',
};

export default columnLabels;
